<template>
  <power-bi
    code="eyJrIjoiYzZhNTI2ZDEtMGI5Yy00MjYzLTg0ZDAtYWEzYjU2YTliNGIwIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"
  />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
